import React, { Fragment, useState, useEffect } from 'react';
import {FormControl , TextField, Grid , Box, Card, CardContent , Typography,CardActions,Button,Select,MenuItem } from '@mui/material/';
import InputLabel from '@mui/material/InputLabel';
import axios from 'axios';

import Autorize from '../../components/ui/autorize';
import { DataGrid, GridToolbar,frFR  } from '@mui/x-data-grid';
import { useParams } from 'react-router';
import Cookies from 'js-cookie'
import RepportBySector from '../../components/reports/list_secteur';


//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
export default function Reports() {

    const [errorAxios, setErrorAxios] = useState("false");
    const [autorize, setAutorize] = useState("false");

    const [secteur, setSecteur] = useState("");
    const [listMembre, setListMembre] = useState([]);
  
  

    useEffect(() => {

    }, []);
       

    
 /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
    const MyAxios = axios.create({    
        headers: { Authorization: "Bearer "+ Cookies.get('token'),
                }      
  })


    function getList(MySecteur)
    {
        if(autorize && MySecteur > 1)
        { 
            MyAxios.get(process.env.REACT_APP_API + '/rapports/get/secteurMembers/' + MySecteur) //axios.defaults.withCredentials = true
            .then((res) => {      
                setErrorAxios(false);
               // console.log(res);
                setListMembre(res.data);
            
            })
            .catch((error) => {
                console.log(error)  
            ///  if(error.status)  
            if(error.response.status === 401)// pas autorisé
                setErrorAxios(true); 

            });

        }  
    } 


    const handleChangeSelectSecteur = (event) => {
        setSecteur(event.target.value);
        getList(event.target.value);
      };


      
      const columns = [           
        {      field: 'id',            headerName: 'id' ,        width: 0 ,     hide: true}  ,
        {      field: 'ClubLegalName',      headerName: 'Nom club' ,    width: 430 ,    }  ,         
        {      field: 'fk_club_type',     headerName: 'Type club' ,  width: 120 ,     }  ,
        {      field: 'fk_club_master',     headerName: 'Club' ,    width: 100 ,   }  ,               
        {      field: 'First_Name',        headerName: 'Prénom' ,    width: 180 ,      }  ,
        {      field: 'Last_Name',        headerName: 'Nom' ,   width: 180 ,       }  ,
        {      field: 'Title',        headerName: 'Titre' ,   width: 100 ,       }  ,         
        {      field: 'Officier',        headerName: 'Officier' ,   width: 200 ,       }  ,     
        {      field: 'Address',        headerName: 'Adresse' ,   width: 200 ,       }  ,           
        {      field: 'City',        headerName: 'Ville' ,   width: 200 ,       }  ,
        {      field: 'State_Province_Code',        headerName: 'Province' ,   width: 100 ,   }  ,   
        {      field: 'Postal_Code',        headerName: 'Code postal' ,   width: 100 ,       }  ,     
        {      field: 'E_Mail_Address',        headerName: 'Courriel' ,   width: 230 ,   }  , 
        {      field: 'Home_Phone_Number',        headerName: 'Téléphonne' ,   width: 170 ,   }  , 
        {      field: 'Cell_Phone_Number',        headerName: 'Cellulaire' ,   width: 170 ,   }  ,             
        {      field: 'Life_Membership_Date_Effective',        headerName: 'Membre à vie' ,       width: 180 ,  }  ,
        {      field: 'BirthMonth',        headerName: "Mois naissance" ,       width: 100 ,   }  ,
        {      field: 'BirthDay',        headerName: "Jour naissance" ,       width: 100 ,   }  ,
      
    ];



      function mainHtml()
      {
  
          if(autorize)
          {
              return (<div>
                          <div style={{  width: '90%', margin: '3%' }}>
                                <Typography variant="h4" gutterBottom>
                                    Rapport des membres par secteur
                                </Typography>

                                <Grid container direction="row" >
                                    <Grid item xs={1} container direction="row" > 
                                        <FormControl sx={{  minWidth: 220 }}>
                                            <InputLabel id="TitleLabel">Secteur</InputLabel>
                                            <Select
                                            labelId="TitleLabel"
                                            id="Title"
                                            value={secteur}
                                            label="Secteur"
                                            onChange={handleChangeSelectSecteur}
                                            >
                                                <MenuItem key={"name-49" } value="49">49</MenuItem>
                                                <MenuItem key={"name-50" } value="50">50</MenuItem>
                                                <MenuItem key={"name-52" } value="52">52</MenuItem>
                                                <MenuItem key={"name-53" } value="53">53</MenuItem>
                                                <MenuItem key={"name-54" } value="54">54</MenuItem>
                                                <MenuItem key={"name-55" } value="55">55</MenuItem>
                                                <MenuItem key={"name-60" } value="60">60</MenuItem>
                                                                                       
                                            </Select>
                                        </FormControl>                                   
                                    </Grid>
                                
                                    <Grid item xs={3} container direction="row" > 
                                                                
                                    </Grid>                                            
                                </Grid>

                                <div style={{ height: '700px', width: '100%' }}>
                                <DataGrid key="DataGridMember" localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
                                        rows={listMembre}
                                        columns={columns}
                                    
                                    
                                       
                                        components={{ Toolbar: GridToolbar }} 
                                        initialState={{
                                            filter: {
                                            filterModel: {
                                                items: [{ columnField: 'DateRadiation', operatorValue:  'isEmpty' }],
                                            },
                                            },
                                        }}
                                        
                                    />
                                  </div>


                               




                                

                            </div>
                      </div>);
          }
          else
              return "";
  
      }
    
      const callbackAutoriser = (index) => { // the callback. Use a better name      
        setAutorize(index);     
      };
        

        return (
           <div>
                <Autorize axiosError={errorAxios} callBackAutoriser={callbackAutoriser}/>

                {mainHtml()}
                   
            </div>
            
        );
   
};

 